// reducers/configuracion.js
import { 
        CONFIGURACION_CATEGORIAS, 
        CONFIGURACION_SUBCATEGORIAS, 
        CONFIGURACION_PRODUCTOS, 
        CONFIGURACION_AREAS, 
        CONFIGURACION_ORGANIZADORES, 
        CONFIGURACION_UBICACIONES, 
        CONFIGURACION_PROVEEDORES_PRODUCTO,
        CONFIGURACION_UNIDADES,
        CONFIGURACION_METODOS_PAGO,
        CONFIGURACION_PAQUETES
    } from '../actions/types';

const initialState = {
    categorias: {
        listado: [],
        detalles: null,
    },
    subcategorias: {
        listado: [],
        detalles: null,
    },
    productos: {
        ventana_filtros: false, 
        listado: [],
        detalles: null,
        codigo_siguiente: null
    },
    unidades: {
        listado: [],
        detalles: null
    },
    subsubcategorias: {
        listado: [],
        detalles: null
    },
    areas: {
        listado: []
    },
    organizadores: {
        listado: [],
        detalle: null,
        areaActual: null   // área de la que se listaron los organizadores
    },
    ubicaciones: {
        listado: [],
        detalle: null,
        organizadorActual: null
    },
    proveedores_producto: {
        listado: []
    },
    metodos_pago: [],
    metodo_pago_detalle: null,
    paquetes: {
        listado: [],
        detalle: null
    },
};

export default function configuracionReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        // Métodos de pago
        case CONFIGURACION_METODOS_PAGO.BUSCAR:
            return {
                ...state,
                metodos_pago: Array.isArray(action.payload) ? action.payload : []
            };

        case CONFIGURACION_METODOS_PAGO.AGREGAR:
            return {
                ...state,
                metodos_pago: [action.payload, ...(state.metodos_pago || [])]
            };

        case CONFIGURACION_METODOS_PAGO.DETALLES:
            return {
                ...state,
                metodo_pago_detalle: action.payload
            };

        case CONFIGURACION_METODOS_PAGO.EDITAR:
            return {
                ...state,
                metodos_pago: (state.metodos_pago || []).map(m =>
                    m?._id === action.payload?._id ? action.payload : m
                ),
                metodo_pago_detalle: action.payload
            };

        case CONFIGURACION_METODOS_PAGO.ELIMINAR:
            return {
                ...state,
                metodos_pago: (state.metodos_pago || []).filter(m => String(m?._id) !== String(action.payload)),
                metodo_pago_detalle: state.metodo_pago_detalle && String(state.metodo_pago_detalle?._id) === String(action.payload)
                    ? null
                    : state.metodo_pago_detalle
            };

        // =======================
        //      SUBCATEGORÍAS
        // =======================
        case CONFIGURACION_SUBCATEGORIAS.BUSCAR:
            return {
                ...state,
                subcategorias: {
                    ...state.subcategorias,
                    listado: payload,
                },
            };

        case CONFIGURACION_SUBCATEGORIAS.AGREGAR: {
            let subcategorias_agregar = state.subcategorias.listado;

            subcategorias_agregar = [
                ...subcategorias_agregar,
                payload,
            ];

            subcategorias_agregar = subcategorias_agregar.sort((a, b) => {
                if (a.nombre > b.nombre) return 1;
                if (a.nombre < b.nombre) return -1;
                return 0;
            });

            return {
                ...state,
                subcategorias: {
                    ...state.subcategorias,
                    listado: subcategorias_agregar,
                },
            };
        }

        case CONFIGURACION_SUBCATEGORIAS.DETALLES:
            return {
                ...state,
                subcategorias: {
                    ...state.subcategorias,
                    detalles: payload,
                },
            };

        case CONFIGURACION_SUBCATEGORIAS.EDITAR: {
            let subcategorias_editar = state.subcategorias.listado;

            // aquí asumo que también usas _id en subcategorías; si no, cambia por id
            subcategorias_editar = subcategorias_editar.map(subcategoria =>
                subcategoria._id === payload._id ? payload : subcategoria
            );

            subcategorias_editar = subcategorias_editar.sort((a, b) => {
                if (a.nombre > b.nombre) return 1;
                if (a.nombre < b.nombre) return -1;
                return 0;
            });

            return {
                ...state,
                subcategorias: {
                    ...state.subcategorias,
                    listado: subcategorias_editar,
                },
            };
        }

        case CONFIGURACION_SUBCATEGORIAS.ELIMINAR:
            return {
                ...state,
                subcategorias: {
                    ...state.subcategorias,
                    listado: state.subcategorias.listado.filter(
                        subcategoria => subcategoria._id !== payload._id
                    ),
                },
            };

        // =======================
        //        CATEGORÍAS
        // =======================
        case CONFIGURACION_CATEGORIAS.BUSCAR:
            return {
                ...state,
                categorias: {
                    ...state.categorias,
                    listado: payload,
                },
            };

        case CONFIGURACION_CATEGORIAS.AGREGAR: {
            let categorias_agregar = state.categorias.listado;

            categorias_agregar = [
                ...categorias_agregar,
                payload,
            ];

            categorias_agregar = categorias_agregar.sort((a, b) => {
                if (a.nombre > b.nombre) return 1;
                if (a.nombre < b.nombre) return -1;
                return 0;
            });

            return {
                ...state,
                categorias: {
                    ...state.categorias,
                    listado: categorias_agregar,
                },
            };
        }

        case CONFIGURACION_CATEGORIAS.DETALLES:
            return {
                ...state,
                categorias: {
                    ...state.categorias,
                    detalles: payload,
                },
            };

        case CONFIGURACION_CATEGORIAS.EDITAR: {
            let categorias_editar = state.categorias.listado;

            categorias_editar = categorias_editar.map(categoria =>
                categoria._id === payload._id ? payload : categoria
            );

            categorias_editar = categorias_editar.sort((a, b) => {
                if (a.nombre > b.nombre) return 1;
                if (a.nombre < b.nombre) return -1;
                return 0;
            });

            return {
                ...state,
                categorias: {
                    ...state.categorias,
                    listado: categorias_editar,
                },
            };
        }

        case CONFIGURACION_CATEGORIAS.ELIMINAR:
            return {
                ...state,
                categorias: {
                    ...state.categorias,
                    listado: state.categorias.listado.filter(
                        categoria => categoria._id !== payload._id
                    ),
                },
            };

        ///
        ///     Productos
        ///
        
         case CONFIGURACION_PRODUCTOS.FILTROS:
            return {
                ...state,
                productos: {
                    ...state.productos, 
                    ventana_filtros: payload
                }
            };
            
        case CONFIGURACION_PRODUCTOS.BUSCAR:
            return {
                ...state,
                productos: {
                    ...state.productos, 
                    listado: payload
                }
            };

        case CONFIGURACION_PRODUCTOS.AGREGAR: {
            if (!payload) return state;

            let productos_agregar = state.productos.listado;

            productos_agregar = [
                ...productos_agregar,
                payload
            ];

            productos_agregar = productos_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) return 1;
                if (a.nombre < b.nombre) return -1;
                return 0;
            });

            return {
                ...state, 
                productos: {
                    ...state.productos, 
                    listado: productos_agregar
                }
            };
        }

        case CONFIGURACION_PRODUCTOS.DETALLES:
            return {
                ...state,
                productos: {
                    ...state.productos, 
                    detalles: payload
                }
            };

        case CONFIGURACION_PRODUCTOS.EDITAR: {
            if (!payload || !payload._id) return state;

            const productos_editar = (state.productos.listado || [])
                .map(p => (String(p._id) === String(payload._id) ? payload : p))
                .sort((a, b) => (a.nombre > b.nombre ? 1 : a.nombre < b.nombre ? -1 : 0));

            return {
                ...state,
                productos: {
                ...state.productos,
                listado: productos_editar,
                detalles:
                    state.productos.detalles && String(state.productos.detalles._id) === String(payload._id)
                    ? payload
                    : state.productos.detalles
                }
            };
        }


        case CONFIGURACION_PRODUCTOS.ELIMINAR:
            return {
                ...state, 
                productos: {
                    ...state.productos, 
                    listado: state.productos.listado.filter(
                        producto => producto._id !== payload._id
                    )
                }
            };

        case CONFIGURACION_PRODUCTOS.ELIMINAR_MULTIPLE:
            return {
                ...state,
                productos: {
                    ...state.productos, 
                    listado: state.productos.listado.filter(
                        producto => !payload.map(id => String(id)).includes(String(producto._id))
                    )
                }
            };
        
        //Proveedores productos
        case CONFIGURACION_PROVEEDORES_PRODUCTO.BUSCAR:
            return {
                ...state,
                proveedores_producto: {
                    ...state.proveedores_producto,
                    listado: payload
                }
            };

        case CONFIGURACION_PROVEEDORES_PRODUCTO.LIMPIAR:
            return {
                ...state,
                proveedores_producto: {
                    ...state.proveedores_producto,
                    listado: []
                }
            };

        case CONFIGURACION_PROVEEDORES_PRODUCTO.ERROR:
            return {
                ...state
            };
        
        case CONFIGURACION_PRODUCTOS.CODIGO_SIGUIENTE: {
            return {
                ...state,
                productos: {
                    ...state.productos,
                    codigo_siguiente: payload
                }
            };
        }
        
        // Areas
        case CONFIGURACION_AREAS.BUSCAR:
            return {
                ...state,
                areas: {
                    ...state.areas,
                    listado: payload
                }
            };

        case CONFIGURACION_AREAS.AGREGAR:
            return {
                ...state,
                areas: {
                    ...state.areas,
                    listado: [
                        ...state.areas.listado,
                        payload
                    ]
                }
            };
        case CONFIGURACION_AREAS.ELIMINAR:
            return {
                ...state,
                areas: {
                    ...state.areas,
                    listado: state.areas.listado.filter(a => a._id !== payload)
                }
            };
        case CONFIGURACION_AREAS.DETALLES:
            return {
                ...state,
                areas: {
                    ...state.areas,
                    detalle: payload
                }
            };

        case CONFIGURACION_AREAS.EDITAR:
            return {
                ...state,
                areas: {
                    ...state.areas,
                    listado: state.areas.listado.map(a =>
                        a._id === payload._id ? payload : a
                    ),
                    detalle: null
                }
            };
        case CONFIGURACION_ORGANIZADORES.BUSCAR: {
            const { organizadores, id_area } = payload;
            return {
                ...state,
                organizadores: {
                    ...state.organizadores,
                    listado: organizadores,
                    areaActual: id_area
                }
            };
        }

        case CONFIGURACION_ORGANIZADORES.AGREGAR: {
            const { organizador, idAreaVista } = payload;
            // Solo se muestra en la vista si pertenece al área actual
            if (organizador.area !== idAreaVista) {
                return state;
            }
            return {
                ...state,
                organizadores: {
                    ...state.organizadores,
                    listado: [...state.organizadores.listado, organizador]
                }
            };
        }

        case CONFIGURACION_ORGANIZADORES.DETALLES:
            return {
                ...state,
                organizadores: {
                    ...state.organizadores,
                    detalle: payload
                }
            };

        case CONFIGURACION_ORGANIZADORES.EDITAR: {
            const { organizador, idAreaVista } = payload;
            let nuevoListado;

            if (organizador.area === idAreaVista) {
                // Sigue en la misma área → se actualiza
                nuevoListado = state.organizadores.listado.map(o =>
                    o._id === organizador._id ? organizador : o
                );
            } else {
                // Se movió a otra área → se quita del listado actual
                nuevoListado = state.organizadores.listado.filter(o =>
                    o._id !== organizador._id
                );
            }

            return {
                ...state,
                organizadores: {
                    ...state.organizadores,
                    listado: nuevoListado,
                    detalle: null
                }
            };
        }

        case CONFIGURACION_ORGANIZADORES.ELIMINAR:
            return {
                ...state,
                organizadores: {
                    ...state.organizadores,
                    listado: state.organizadores.listado.filter(o => o._id !== payload)
                }
            };
        
            case CONFIGURACION_UBICACIONES.BUSCAR: {
            const { ubicaciones, id_organizador } = payload;
            return {
                ...state,
                ubicaciones: {
                    ...state.ubicaciones,
                    listado: ubicaciones,
                    organizadorActual: id_organizador
                }
            };
        }

        case CONFIGURACION_UBICACIONES.AGREGAR: {
            const { ubicacion, idOrganizadorVista } = payload;

            // Solo agregamos a la tabla si pertenece al organizador actual
            if (ubicacion.organizador !== idOrganizadorVista) {
                return state;
            }

            return {
                ...state,
                ubicaciones: {
                    ...state.ubicaciones,
                    listado: [...state.ubicaciones.listado, ubicacion]
                }
            };
        }

        case CONFIGURACION_UBICACIONES.DETALLES:
            return {
                ...state,
                ubicaciones: {
                    ...state.ubicaciones,
                    detalle: payload
                }
            };

        case CONFIGURACION_UBICACIONES.EDITAR: {
            const { ubicacion, idOrganizadorVista } = payload;

            let nuevoListado;
            if (ubicacion.organizador === idOrganizadorVista) {
                // Sigue en el mismo organizador
                nuevoListado = state.ubicaciones.listado.map(u =>
                    u._id === ubicacion._id ? ubicacion : u
                );
            } else {
                // Se movió a otro organizador → se saca de la tabla
                nuevoListado = state.ubicaciones.listado.filter(u =>
                    u._id !== ubicacion._id
                );
            }

            return {
                ...state,
                ubicaciones: {
                    ...state.ubicaciones,
                    listado: nuevoListado,
                    detalle: null
                }
            };
        }

        case CONFIGURACION_UBICACIONES.ELIMINAR:
            return {
                ...state,
                ubicaciones: {
                    ...state.ubicaciones,
                    listado: state.ubicaciones.listado.filter(u => u._id !== payload)
                }
            };
        
        //Unidades
        case CONFIGURACION_UNIDADES.BUSCAR:
            return {
                ...state,
                unidades: {
                    ...state.unidades,
                    listado: payload
                }
            };

        case CONFIGURACION_UNIDADES.LIMPIAR:
            return {
                ...state,
                unidades: {
                    ...state.unidades,
                    listado: []
                }
            };

        case CONFIGURACION_UNIDADES.CREAR: {
            const nuevo = payload;
            if (!nuevo?._id) return { ...state };

            const actual = state.unidades?.listado || [];
            const existe = actual.some(u => (u?._id + '') === (nuevo._id + ''));

            return {
                ...state,
                unidades: {
                    ...state.unidades,
                    listado: existe ? actual : [nuevo, ...actual]
                }
            };
        }

        case CONFIGURACION_UNIDADES.EDITAR: {
            const editado = payload;
            if (!editado?._id) return { ...state };

            const actual = state.unidades?.listado || [];
            const nuevoListado = actual.map(u => {
                if ((u?._id + '') === (editado._id + '')) return editado;
                return u;
            });

            return {
                ...state,
                unidades: {
                    ...state.unidades,
                    listado: nuevoListado
                }
            };
        }

        case CONFIGURACION_UNIDADES.ELIMINAR: {
            const id = payload;
            const actual = state.unidades?.listado || [];
            const nuevoListado = actual.filter(u => (u?._id + '') !== (id + ''));

            return {
                ...state,
                unidades: {
                    ...state.unidades,
                    listado: nuevoListado
                }
            };
        }

        case CONFIGURACION_UNIDADES.CREAR_ERROR:
        case CONFIGURACION_UNIDADES.EDITAR_ERROR:
        case CONFIGURACION_UNIDADES.ELIMINAR_ERROR:
        case CONFIGURACION_UNIDADES.ERROR:
            return {
                ...state
            };

        // Paquetes
        case CONFIGURACION_PAQUETES.BUSCAR:
            return {
                ...state,
                paquetes: {
                    ...state.paquetes,
                    listado: payload
                }
            };

        case CONFIGURACION_PAQUETES.LIMPIAR:
            return {
                ...state,
                paquetes: {
                    ...state.paquetes,
                    listado: []
                }
            };

        case CONFIGURACION_PAQUETES.DETALLE:
            return {
                ...state,
                paquetes: {
                    ...state.paquetes,
                    detalle: payload
                }
            };

        case CONFIGURACION_PAQUETES.LIMPIAR_DETALLE:
            return {
                ...state,
                paquetes: {
                    ...state.paquetes,
                    detalle: null
                }
            };

        case CONFIGURACION_PAQUETES.CREAR: {
            const nuevo = payload;
            if (!nuevo?._id) return { ...state };

            const actual = state.paquetes?.listado || [];
            const existe = actual.some(p => (p?._id + '') === (nuevo._id + ''));

            return {
                ...state,
                paquetes: {
                    ...state.paquetes,
                    listado: existe ? actual : [nuevo, ...actual]
                }
            };
        }

        case CONFIGURACION_PAQUETES.EDITAR: {
            const editado = payload;
            if (!editado?._id) return { ...state };

            const actual = state.paquetes?.listado || [];
            const nuevoListado = actual.map(p => {
                if ((p?._id + '') === (editado._id + '')) return editado;
                return p;
            });

            return {
                ...state,
                paquetes: {
                    ...state.paquetes,
                    listado: nuevoListado
                }
            };
        }

        case CONFIGURACION_PAQUETES.ELIMINAR: {
            const id = payload;
            const actual = state.paquetes?.listado || [];
            const nuevoListado = actual.filter(p => (p?._id + '') !== (id + ''));

            return {
                ...state,
                paquetes: {
                    ...state.paquetes,
                    listado: nuevoListado
                }
            };
        }

        case CONFIGURACION_PAQUETES.CREAR_ERROR:
        case CONFIGURACION_PAQUETES.EDITAR_ERROR:
        case CONFIGURACION_PAQUETES.ELIMINAR_ERROR:
        case CONFIGURACION_PAQUETES.ERROR:
            return {
                ...state
            };

        // =======================
        //      DEFAULT (CLAVE)
        // =======================
        default:
            return state;
    }
}
